import Dashboard from "layouts/Dashboards";
import Profile from "layouts/Profiles";
import SignIn from "layouts/Authentications/sign-in";
import Icon from "@mui/material/Icon";
import Cover from "layouts/Authentications/forgot-password/cover/index";
import ResetPassword from "layouts/Authentications/reset-password";
import { OtpConfirmation } from "layouts/Authentications/otp";
import Members from "layouts/Page/member";
import BusinessTable from "layouts/Page/business";
import MetrimonialTable from "layouts/Page/metrimonial";
import Booking from "layouts/Page/booking";
import Admins from "layouts/Page/admin";
import Roles from "layouts/Page/role";
import Posts from "layouts/Page/post";
import { MODULES } from "helpers/constant";
import Advertisement from "layouts/Page/advertisement";
import AboutUs from "layouts/Page/aboutUs";
import Event from "layouts/Page/event";
import { AuthRouteJson } from "helpers/constant";
import Districts from "layouts/Page/district";
import Banner from "layouts/Page/banner";
import Committees from "layouts/Page/committee";
import Settings from "layouts/Page/setting";
import BusinessCategory from "layouts/Page/businessCategory";
import BusinessSubCategory from "layouts/Page/BusinessSubCategory";
import DistrictList from "layouts/Page/districts";
import TalukaList from "layouts/Page/taluka";
import VillageList from "layouts/Page/village";
import Trustee from "layouts/Page/trustee";
import EventBooking from "layouts/Page/eventBooking";
import QRTemplate from "layouts/Page/qr-template/index";
import EventAttendances from "layouts/Page/eventAttendance/index";
import Amenity from "layouts/Page/amenity";
import Occasion from "layouts/Page/occasion";
import ReserveDate from "layouts/Page/reserveDate";
import AmenityBooking from "layouts/Page/amenityBooking";
import AddOns from "layouts/Page/addOns";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: AuthRouteJson.dashboard,
    component: <Dashboard />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Admins",
    key: "admins",
    moduleName: MODULES.ADMIN,
    icon: <Icon fontSize="small">person_add</Icon>,
    route: AuthRouteJson.admins,
    component: <Admins />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Roles",
    key: "roles",
    moduleName: MODULES.ROLE,
    icon: <Icon fontSize="small">security</Icon>,
    route: AuthRouteJson.roles,
    component: <Roles />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Members",
    key: "members",
    moduleName: MODULES.MEMBER,
    icon: <Icon fontSize="small">group</Icon>,
    route: AuthRouteJson.members,
    component: <Members />,
    noCollapse: true,
  },
  // {
  //   type: "collapse",
  //   name: "Events",
  //   key: "events",
  //   moduleName: MODULES.EVENT,
  //   icon: <Icon fontSize="small">event</Icon>,
  //   route: AuthRouteJson.events,
  //   component: <Event />,
  //   noCollapse: true,
  // },
  // {
  //   type: "collapse",
  //   name: "Event Bookings",
  //   key: "event_booking",
  //   moduleName: MODULES.EVENT_BOOKING,
  //   icon: <Icon fontSize="small">booking</Icon>,
  //   route: AuthRouteJson.event_bookings,
  //   component: <EventBooking />,
  //   noCollapse: true,
  // },
  {
    type: "collapse",
    name: "Events",
    key: "event",
    icon: <Icon fontSize="small">event</Icon>,
    noCollapse: false,
    collapse: [
      {
        type: "collapse",
        name: "List",
        key: "events",
        moduleName: MODULES.EVENT,
        icon: (
          <Icon fontSize="inherit" sx={{ fontSize: "0.6rem  !important" }}>
            fiber_manual_record
          </Icon>
        ),
        route: AuthRouteJson.events,
        component: <Event />,
        noCollapse: true,
      },
      {
        type: "collapse",
        name: "Bookings",
        key: "event_booking",
        moduleName: MODULES.EVENT_BOOKING,
        icon: (
          <Icon fontSize="inherit" sx={{ fontSize: "0.6rem !important" }}>
            fiber_manual_record
          </Icon>
        ),
        route: AuthRouteJson.event_bookings,
        component: <EventBooking />,
        noCollapse: true,
      },
      {
        type: "collapse",
        name: "QR Template",
        key: "qr_template",
        moduleName: MODULES.QR_TEMPLATE,
        icon: (
          <Icon fontSize="inherit" sx={{ fontSize: "0.6rem !important" }}>
            fiber_manual_record
          </Icon>
        ),
        route: AuthRouteJson.qr_template,
        component: <QRTemplate />,
        noCollapse: true,
      },
      {
        type: "collapse",
        name: "Event Attendance",
        key: "qr_template",
        moduleName: MODULES.EVENT_ATTENDANCE,
        icon: (
          <Icon fontSize="inherit" sx={{ fontSize: "0.6rem !important" }}>
            fiber_manual_record
          </Icon>
        ),
        route: AuthRouteJson.event_attendance,
        component: <EventAttendances />,
        noCollapse: true,
      },
    ],
  },
  {
    type: "collapse",
    name: "Posts",
    key: "posts",
    moduleName: MODULES.POST,
    icon: <Icon fontSize="small">post_add</Icon>,
    route: AuthRouteJson.posts,
    component: <Posts />,
    noCollapse: true,
  },
  // {
  //   type: "collapse",
  //   name: "Amenity",
  //   key: "amenity",
  //   moduleName: MODULES.AMENITY,
  //   icon: <Icon fontSize="small">home_work</Icon>,
  //   route: AuthRouteJson.amenity,
  //   component: <Amenity />,
  //   noCollapse: true,
  // },
  // {
  //   type: "collapse",
  //   name: "Occasion",
  //   key: "occasion",
  //   moduleName: MODULES.OCCASION,
  //   icon: <Icon fontSize="small">celebration</Icon>,
  //   route: AuthRouteJson.occasion,
  //   component: <Occasion />,
  //   noCollapse: true,
  // },
  {
    type: "collapse",
    name: "Amenity Booking",
    key: "amenity",
    icon: <Icon fontSize="small">home_work</Icon>,
    noCollapse: false,
    collapse: [
      {
        type: "collapse",
        name: "Amenity List",
        key: "amenity",
        moduleName: MODULES.AMENITY,
        icon: (
          <Icon fontSize="inherit" sx={{ fontSize: "0.6rem  !important" }}>
            fiber_manual_record
          </Icon>
        ),
        route: AuthRouteJson.amenity,
        component: <Amenity />,
        noCollapse: true,
      },
      {
        type: "collapse",
        name: "Occasion List",
        key: "occasion",
        moduleName: MODULES.OCCASION,
        icon: (
          <Icon fontSize="inherit" sx={{ fontSize: "0.6rem  !important" }}>
            fiber_manual_record
          </Icon>
        ),
        route: AuthRouteJson.occasion,
        component: <Occasion />,
        noCollapse: true,
      },
      {
        type: "collapse",
        name: "Add Ons List",
        key: "occasion",
        moduleName: MODULES.ADD_ONS,
        icon: (
          <Icon fontSize="inherit" sx={{ fontSize: "0.6rem  !important" }}>
            fiber_manual_record
          </Icon>
        ),
        route: AuthRouteJson.add_ons,
        component: <AddOns />,
        noCollapse: true,
      },
      // {
      //   type: "collapse",
      //   name: "Reserve Date List",
      //   key: "reserve_date",
      //   moduleName: MODULES.RESERVE_DATE,
      //   icon: (
      //     <Icon fontSize="inherit" sx={{ fontSize: "0.6rem  !important" }}>
      //       fiber_manual_record
      //     </Icon>
      //   ),
      //   route: AuthRouteJson.reserve_date,
      //   component: <ReserveDate />,
      //   noCollapse: true,
      // },
      {
        type: "collapse",
        name: "Amenity Booking",
        key: "booking",
        moduleName: MODULES.AMENITY_BOOKING,
        icon: (
          <Icon fontSize="inherit" sx={{ fontSize: "0.6rem  !important" }}>
            fiber_manual_record
          </Icon>
        ),
        route: AuthRouteJson.booking,
        component: <AmenityBooking />,
        noCollapse: true,
      },
    ],
  },
  {
    type: "collapse",
    name: "Samaj Booking",
    key: "booking",
    moduleName: MODULES.SAMAJ_BOOKING,
    icon: <Icon fontSize="small">calendar_today</Icon>,
    route: AuthRouteJson.samaj_booking,
    component: <Booking />,
    noCollapse: true,
  },
  // {
  //   type: "collapse",
  //   name: "Businesses",
  //   key: "business",
  //   moduleName: MODULES.BUSINESS,
  //   icon: <Icon fontSize="small">business</Icon>,
  //   route: AuthRouteJson.business,
  //   component: <BusinessTable />,
  //   noCollapse: true,
  // },
  // {
  //   type: "collapse",
  //   name: "Business Categories",
  //   key: "business_category",
  //   moduleName: MODULES.BUSINESS_CATEGORY,
  //   icon: <Icon fontSize="small">category</Icon>,
  //   route: AuthRouteJson.business_category,
  //   component: <BusinessCategory />,
  //   noCollapse: true,
  // },
  // {
  //   type: "collapse",
  //   name: "Business Subcategories",
  //   key: "business_subcategory",
  //   moduleName: MODULES.BUSINESS_SUB_CATEGORY,
  //   icon: <Icon fontSize="small">layers</Icon>,
  //   route: AuthRouteJson.business_subcategory,
  //   component: <BusinessSubCategory />,
  //   noCollapse: true,
  // },
  {
    type: "collapse",
    name: "Businesses",
    key: "businesses",
    icon: <Icon fontSize="small">business</Icon>,
    noCollapse: false,
    collapse: [
      {
        type: "collapse",
        name: "Business List",
        key: "business",
        moduleName: MODULES.BUSINESS,
        icon: (
          <Icon fontSize="inherit" sx={{ fontSize: "0.6rem  !important" }}>
            fiber_manual_record
          </Icon>
        ),
        route: AuthRouteJson.business,
        component: <BusinessTable />,
        noCollapse: true,
      },
      {
        type: "collapse",
        name: "Category",
        key: "business_category",
        moduleName: MODULES.BUSINESS_CATEGORY,
        icon: (
          <Icon fontSize="inherit" sx={{ fontSize: "0.6rem  !important" }}>
            fiber_manual_record
          </Icon>
        ),
        route: AuthRouteJson.business_category,
        component: <BusinessCategory />,
        noCollapse: true,
      },
      {
        type: "collapse",
        name: "Sub Category",
        key: "business_subcategory",
        moduleName: MODULES.BUSINESS_SUB_CATEGORY,
        icon: (
          <Icon fontSize="inherit" sx={{ fontSize: "0.6rem  !important" }}>
            fiber_manual_record
          </Icon>
        ),
        route: AuthRouteJson.business_subcategory,
        component: <BusinessSubCategory />,
        noCollapse: true,
      },
    ],
  },
  {
    type: "collapse",
    name: "Matrimonials",
    key: "matrimonial",
    moduleName: MODULES.MATRIMONIAL,
    icon: <Icon fontSize="small">favorite</Icon>,
    route: AuthRouteJson.matrimonial,
    component: <MetrimonialTable />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Advertisements",
    key: "advertisement",
    moduleName: MODULES.ADVERTISEMENTS,
    icon: <Icon fontSize="small"> campaign</Icon>,
    route: AuthRouteJson.advertisement,
    component: <Advertisement />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Banners",
    key: "banner",
    moduleName: MODULES.BANNER,
    icon: <Icon fontSize="small"> photo_library</Icon>,
    route: AuthRouteJson.banner,
    component: <Banner />,
    noCollapse: true,
  },
  // {
  //   type: "collapse",
  //   name: "Locations",
  //   key: "location",
  //   moduleName: MODULES.LOCATION,
  //   icon: <Icon fontSize="small">location_on</Icon>,
  //   route: AuthRouteJson.location,
  //   component: <Districts />,
  //   noCollapse: true,
  // },
  {
    type: "collapse",
    name: "Management",
    key: "community-management",
    icon: <Icon fontSize="small">group</Icon>,
    noCollapse: false,
    collapse: [
      {
        type: "collapse",
        name: "Committee",
        key: "committee",
        moduleName: MODULES.COMMITTEE,
        icon: (
          <Icon fontSize="inherit" sx={{ fontSize: "0.6rem  !important" }}>
            fiber_manual_record
          </Icon>
        ),
        route: AuthRouteJson.committee,
        component: <Committees />,
        noCollapse: true,
      },
      {
        type: "collapse",
        name: "Trustee",
        key: "trustee",
        moduleName: MODULES.TRUSTEE,
        icon: (
          <Icon fontSize="inherit" sx={{ fontSize: "0.6rem  !important" }}>
            fiber_manual_record
          </Icon>
        ),
        route: AuthRouteJson.trustee,
        component: <Trustee />,
        noCollapse: true,
      },
      {
        type: "collapse",
        name: "About us",
        key: "about-us",
        moduleName: MODULES.INFORMATION,
        icon: (
          <Icon fontSize="inherit" sx={{ fontSize: "0.6rem  !important" }}>
            fiber_manual_record
          </Icon>
        ),
        route: AuthRouteJson.aboutus,
        component: <AboutUs />,
        noCollapse: true,
      },
    ],
  },
  // {
  //   type: "collapse",
  //   name: "Committee",
  //   key: "committee",
  //   moduleName: MODULES.COMMITTEE,
  //   icon: <Icon fontSize="small">group</Icon>,
  //   route: AuthRouteJson.committee,
  //   component: <Committees />,
  //   noCollapse: true,
  // },
  // {
  //   type: "collapse",
  //   name: "Trustee",
  //   key: "trustee",
  //   moduleName: MODULES.TRUSTEE,
  //   icon: <Icon fontSize="small">person</Icon>,
  //   route: AuthRouteJson.trustee,
  //   component: <Trustee />,
  //   noCollapse: true,
  // },
  {
    type: "collapse",
    name: "Location",
    key: "location",
    icon: <Icon fontSize="small">place</Icon>,
    noCollapse: false,
    collapse: [
      {
        type: "collapse",
        name: "Districts",
        key: "district",
        moduleName: MODULES.DISTRICT,
        icon: (
          <Icon fontSize="inherit" sx={{ fontSize: "0.6rem  !important" }}>
            fiber_manual_record
          </Icon>
        ),
        route: AuthRouteJson.district,
        component: <DistrictList />,
        noCollapse: true,
      },
      {
        type: "collapse",
        name: "Talukas",
        key: "taluka",
        moduleName: MODULES.TALUKA,
        icon: (
          <Icon fontSize="inherit" sx={{ fontSize: "0.6rem  !important" }}>
            fiber_manual_record
          </Icon>
        ),
        route: AuthRouteJson.taluka,
        component: <TalukaList />,
        noCollapse: true,
      },
      {
        type: "collapse",
        name: "Villages",
        key: "village",
        moduleName: MODULES.VILLAGE,
        icon: (
          <Icon fontSize="inherit" sx={{ fontSize: "0.6rem  !important" }}>
            fiber_manual_record
          </Icon>
        ),
        route: AuthRouteJson.village,
        component: <VillageList />,
        noCollapse: true,
      },
    ],
  },
  {
    type: "collapse",
    name: "Settings",
    key: "setting",
    moduleName: MODULES.SETTING,
    icon: <Icon fontSize="small">settings</Icon>,
    route: AuthRouteJson.setting,
    component: <Settings />,
    noCollapse: true,
  },
  // {
  //   type: "collapse",
  //   name: "About us",
  //   key: "about-us",
  //   moduleName: MODULES.INFORMATION,
  //   icon: <Icon fontSize="small">info</Icon>,
  //   route: AuthRouteJson.aboutus,
  //   component: <AboutUs />,
  //   noCollapse: true,
  // },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: AuthRouteJson.profile,
    component: <Profile />,
    noCollapse: true,
  },
  {
    // type: "collapse",
    // name: "Sign In",
    key: "sign-in",
    // icon: <Icon fontSize="small">login</Icon>,
    route: AuthRouteJson.signin,
    component: <SignIn />,
    noCollapse: true,
  },
  {
    // type: "collapse",
    // name: "Reset Password",
    key: "forgot-password",
    // icon: <Icon fontSize="small">assignment</Icon>,
    route: AuthRouteJson.forgotpassword,
    component: <Cover />,
    noCollapse: true,
  },
  {
    // type: "collapse",
    // name: "Reset Password",
    key: "reset-password",
    // icon: <Icon fontSize="small">assignment</Icon>,
    route: AuthRouteJson.resetpassword,
    component: <ResetPassword />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Logout",
    key: "logout",
    // route: AuthRouteJson.signin,
    icon: <Icon fontSize="medium">logout</Icon>,
    component: <SignIn />,
    noCollapse: true,
  },
  {
    // type: "collapse",
    // name: "otp",
    key: "otp",
    route: AuthRouteJson.otp,
    component: <OtpConfirmation />,
    noCollapse: true,
  },
];

export default routes;

export function getAccessByModuleName(modules, moduleName) {
  return modules.find((module) => module.name === moduleName);
}
